import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import type { Connector } from 'react-redux'
import cn from 'classnames'
import selectedCoinObj from '../../../../selectors/selectedCoinObj';
import SocialMediaBox from '../../../components/socialMediaBox'
import { setTrackedDays } from '../../../../actions/ui/index.js'
//import PremiumBar from './premiumBar'
import Chart from '../../../components/chart'
import DateSetter from './dateSetter'
import './styles.css'

class ChartView extends PureComponent {

  render(){
    const { coin, setTrackedDays, trackedDays, adminMode } = this.props

    return(
      <fb className="chartViewMain">
        <fb className="blueBar"></fb>
        <fb className="actionsLine">
          <fb className="mainRow">
            <fb className="coinName">{ coin.name }</fb>
            <fb className="mcap">
              <fb className="label">Market Cap:</fb>
              <fb className="number">{ Math.round(coin.mcap / 1000000) + ' m' }</fb>
            </fb>
          </fb>
          <fb className="configsRow">
            <fb className="trackedDays">
              <fb className={cn({btn: 1, active: trackedDays === 30  })} onClick={() => setTrackedDays(30)}>30 Days</fb>
              <fb className={cn({btn: 1, active: trackedDays === 14  })} onClick={() => setTrackedDays(14)}>14 Days</fb>
              <fb className={cn({btn: 1, active: trackedDays === 7  })} onClick={() => setTrackedDays(7)}>7 Days</fb>
            </fb>
            { adminMode && <fb className={cn({btn: 1, active: trackedDays === 1  })} onClick={() => setTrackedDays(1)}>1 Day</fb> }
            { adminMode && <DateSetter /> }
          </fb>
        </fb>
        {/* <PremiumBar /> */}
        <fb className="app-chart-container">
          <Chart />
        </fb>
        <fb className="midPart">
          <SocialMediaBox />
        </fb>
        <fb className="footer">
          <fb className="row">
            For support or feedback please get in touch through twitter
            <a className="twitterLink" target="_blank" rel='noopener noreferrer' href='https://twitter.com/crypto_runup'>@crypto_runup</a>
          </fb>
          <fb className="row">
            Altcoin-Prices provided by
            <a className="link" target="_blank" rel='noopener noreferrer' href='https://min-api.cryptocompare.com/'>cryptocompare.com</a>
          </fb>
        </fb>
      </fb>
    )
  }
}

const actionsToProps = {
  setTrackedDays,
}

const mapStateToProps = (state: Store) => ({
  trackedDays: state.ui.trackedDays,
  priceInSatoshi: state.priceInSatoshi,
  coin: selectedCoinObj(state)
})

const connector: Connector<{}, Props> = connect(mapStateToProps, actionsToProps)
export default connector(ChartView)



// WEBPACK FOOTER //
// ./src/containers/app/main/chartView/index.js